import { EnumElementStatus } from '../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumElementStatus';
import { Product } from '../../../../../api/com/MetaPattern/MDA/MD/Base/Product';
import { BaseComponent } from '../../../../../api/com/MetaPattern/MDA/MD/Base/BaseComponent';

/** IDE中的产品树结构 */
export class ProductTree {
  id: string;
  status: EnumElementStatus;
  /** 设计期ID : 设计期ID */
  designId: string;
  /** 名称 : 元数据名称 */
  name: string;
  /** 显示名称 : 元数据的显示名称 */
  displayName: string;
  /** 描述 : 元数据的描述 */
  description: string;
  /** 应用 */
  product: Product;
  /** 组件 */
  components: Array<BaseComponent>;

  constructor(product: Product) {
    this.product = product;
    this.id = product.id;
    this.status = product.status;
    this.designId = product.designId;
    this.name = product.name;
    this.displayName = product.displayName;
    this.description = product.description;
    this.components = new Array<BaseComponent>();
    product.productComponents.forEach(com => this.components.push(com));
  }
}
